import React, { FC } from "react";
import * as Styled from "./signUp.styles";

const BoxHeader = ({
  data,
  text,
}: {
  data: string;
  text: string;
}) => {
  return (
    <Styled.DataCard>
      <h1 className="display-large">{data}</h1>
      <p className="headline-small">{text}</p>
    </Styled.DataCard>
  );
};

export const TableDescription: FC = () => {
  const items = [
    {
      title: "Asset Management",
      icon: "/assets/freeTrial/table/item1.svg",
    },
    {
      title: "Monitoring",
      icon: "/assets/freeTrial/table/item2.svg",
    },
    {
      title: "Maintenance",
      icon: "/assets/freeTrial/table/item3.svg",
    },
    {
      title: "Warranty Tracking",
      icon: "/assets/freeTrial/table/item4.svg",
    },
    {
      title: "Data Analysis",
      icon: "/assets/freeTrial/table/item5.svg",
    },
    {
      title: "SoH Forecast",
      icon: "/assets/freeTrial/table/item6.svg",
    },
  ];
  return (
    <Styled.TableContainer>
      <Styled.TableBox>
        <Styled.Header>
          <BoxHeader data="Our" text="main features" />
          <BoxHeader data="30" text="days license" />
        </Styled.Header>
        {items.map((item) => (
          <Styled.TableRow key={item.title}>
            <Styled.RowDescription>
              <img src={item.icon} alt="icon" />
              <p className="body-large">{item.title}</p>
            </Styled.RowDescription>
            <Styled.RowTilde>
              <img
                src="/assets/freeTrial/table/tilde.svg"
                alt="tilde"
              />
            </Styled.RowTilde>
          </Styled.TableRow>
        ))}
      </Styled.TableBox>
    </Styled.TableContainer>
  );
};
